export const USER_PUBLIC_PROFILE = (userId) => `/user-profile/${userId}`;
export const ROLE_ACTIVATE = `/activation/entry`;
